import {
  CITIES_FETCHING,
  FETCH_CITIES,
  FILTER_CITIES_BY_PATTERN,
  FIND_CITY,
} from "../actions/types";

const initialState = {
  items: [],
  loadedItems: [],
  filteredItems: [],
  found: null,
  isFetching: false,
  loader: "",
  limit: 0,
  offset: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CITIES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_CITIES:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loadedItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      };

    case FIND_CITY:
      return {
        ...state,
        found: action.payload,
      };

    default:
      return state;
  }
}
